import React from 'react';
import styled from 'styled-components';
import { MdErrorOutline } from 'react-icons/md';
interface Props {
    title: string;
    msg: string;
    onClose: () => void;
}

const Container = styled.div`
    .background {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: linear-gradient(294.31deg, #4273b6 18.45%, #77a1ce 97.62%);
        overflow: auto;
    }
    .card {
        background-color: #fff;
        box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.25);
        border-radius: 3px;
        width: 470px;
        margin: 90px auto 0;
        padding: 28px;
        text-align: center;
        @media only screen and (max-width: ${props =>
                props.theme.breakpoints.md}px) {
            width: 96%;
            margin: 12px auto;
        }
        .image {
            margin-bottom: 20px;
            svg {
                font-size: 168px;
                color: #3b75c3;
            }
            @media only screen and (max-width: ${props =>
                    props.theme.breakpoints.md}px) {
                svg {
                    font-size: 88px;
                }
            }
        }
        h2 {
            font-size: 24px;
            margin: 0 auto 20px;
            max-width: 450px;
        }
        p {
            font-size: 16px;
            opacity: 0.8;
            margin: 0 auto 60px;
            max-width: 450px;
            @media only screen and (max-width: ${props =>
                    props.theme.breakpoints.md}px) {
                margin: 0 auto 20px;
            }
        }
        .close_button {
            border-radius: 3px;
            cursor: pointer;
            background-color: #4273b6;
            color: #fff;
            font-weight: bold;
            padding: 18px 0;
            margin: 10px auto;
            font-size: 16px;
            transition: all 0.2s;
            max-width: 450px;
            &:hover {
                background-color: #77a1ce;
            }
        }
    }
`;

export default ({ title, msg, onClose }: Props) => (
    <Container>
        <div className="background">
            <div className="card">
                <div className="image">
                    <MdErrorOutline />
                </div>
                <h2>{title}</h2>
                <p>{msg}</p>
                <div className="close_button" onClick={onClose}>
                    Fortsätt ändå
                </div>
            </div>
        </div>
    </Container>
);



// WEBPACK FOOTER //
// ./src/components/NoSupportDialog.tsx